import PropTypes from 'prop-types';

export default function ViewableSites({ viewableSitesIds, accountStatus, siteNames }) {
  const viewableSites = (() => {
    if (accountStatus === 'approved' && !viewableSitesIds.length) {
      return 'All sites';
    }
    if (['denied', 'pending'].includes(accountStatus)) {
      return '-';
    }
    return siteNames
      .filter((site) => viewableSitesIds.includes(site.id))
      .map((obj) => obj.name)
      .join(', ');
  })();

  return <p>{viewableSites}</p>;
}

ViewableSites.propTypes = {
  viewableSitesIds: PropTypes.array.isRequired,
  accountStatus: PropTypes.string.isRequired,
  siteNames: PropTypes.array.isRequired,
};
